(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2611],{

/***/ 37241:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/coaches",
      function () {
        return __webpack_require__(84873);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);




function Cookies(props) {
    if (props.showPolicy) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            id: "cookies",
            className: "fixed w-full bottom-0 z-50 p-3 mb-0 bg-slate-400 flex justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: function() {
                        return props.setShowPolicy(false);
                    },
                    className: "mx-3 text-white hover:text-slate-300",
                    style: {
                        fontSize: 25
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-white text-center mb-0",
                    children: [
                        "By using this site, you agree to our",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/cookie-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Cookie Policy "
                                })
                            })
                        }),
                        "and",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/privacy-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Privacy Policy"
                                })
                            })
                        })
                    ]
                })
            ]
        }));
    }
    return null;
};


/***/ }),

/***/ 84114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(69065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./contexts/Auth.js
var Auth = __webpack_require__(92842);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-intercom/dist/index.js
var dist = __webpack_require__(33854);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(52500);
// EXTERNAL MODULE: ./components/Cookies.js
var Cookies = __webpack_require__(36076);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/Layouts/Navbars/BizNav.js













var navigation = [];
function HomeNav() {
    var ref = (0,Auth/* useAuth */.a)(), user = ref.user, signOut = ref.signOut;
    var ref1 = (0,react.useState)(false), showPolicy = ref1[0], setShowPolicy = ref1[1];
    (0,react.useEffect)(function() {
        if (!config/* dev */.WI && user) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                name: "",
                email: user ? user.email : "",
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        } else if (!config/* dev */.WI) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        }
        var cook = (0,lib.getCookie)("policy");
        if (!cook) {
            setShowPolicy(true);
            (0,lib.setCookie)("policy", "true");
        }
    }, [
        user
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        as: "header",
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cookies/* default */.Z, {
                showPolicy: showPolicy,
                setShowPolicy: setShowPolicy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-slate-200/50 pt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6",
                    "aria-label": "Global",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-1 justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full md:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Plaza"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        alt: "Plaza Logo",
                                                        src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                                        width: 128,
                                                        height: 64,
                                                        objectFit: "contain"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-mr-2 flex items-center md:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                className: "bg-gray-900 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden space-x-8 md:!flex md:ml-10 md:mr-10",
                                    children: navigation.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-base font-medium text-slate-500 hover:text-gray-800",
                                                children: item.name
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center text-base font-medium text-gray-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return signOut();
                                        },
                                        className: "text-gray-900 hover:underline",
                                        children: "Logout"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-base font-medium text-slate-900 hover:text-gray-600",
                                        children: "Log in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "#bookDemo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Book a Demo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-100 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    focus: true,
                    className: "absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5 pt-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            alt: "Plaza",
                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                            width: 128,
                                            height: 64,
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mr-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-fuchsia-600",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-5 pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2 space-y-1",
                                        children: navigation.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50",
                                                    children: item.name
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 px-5",
                                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                        children: "Dashboard"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center mt-4 text-base font-medium text-gray-600",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            return signOut();
                                                        },
                                                        className: "text-gray-900 hover:underline",
                                                        children: "Logout"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 px-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "#bookDemo",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                            children: "Book a Demo"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-center text-base font-medium text-gray-600",
                                                    children: [
                                                        "Existing customer?",
                                                        ' ',
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: "/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "text-gray-900 hover:underline",
                                                                children: "Login"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/Layouts/businessLayout.js



var Footer = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3474).then(__webpack_require__.bind(__webpack_require__, 73193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73193)
            ];
        }
    }
});
function Layout(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNav, {}),
            children
        ]
    }));
};


/***/ }),

/***/ 18549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


//Could use a package called next-seo
function Meta(param) {
    var title = param.title, description = param.description, image = param.image, url = param.url;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: "utf-8"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    href: "/favicon.ico"
                }),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: url
                        }, "canonical"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: url
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "website"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: "https://plaza.so/"
                }),
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: image
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: title
                })
            ]
        })
    }));
};


/***/ }),

/***/ 84873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Network; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65988);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(12450);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37051);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25504);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52500);
/* harmony import */ var _styles_Business_module_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(90260);
/* harmony import */ var _styles_Business_module_css__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_styles_Business_module_css__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _components_Layouts_businessLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84114);
/* harmony import */ var _components_Notification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96691);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19412);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92842);
/* harmony import */ var _components_Gthr_Scheduler_Utils_Calendar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64881);
/* harmony import */ var _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6644);
/* harmony import */ var _components_Meta__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18549);
/* harmony import */ var _lib_gtag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);



















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var navigation = (/* unused pure expression or super */ null && ([]));
function Network() {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles";
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), /*#__PURE__*/ subPage = ref8[0], setSubPage = ref8[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), error1 = ref3[0], setError = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true), checkUser = ref4[0], setCheckUser = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        "name": "",
        "person": "",
        "email": "",
        "notes": "",
        "dateStr": null,
        "rand": (Math.random() + 1).toString(36).substring(7),
        "client_profile_id": null,
        "appointment_datetime": null,
        "client_user_id": null,
        "timezone": tz,
        "meeting_dates": []
    }), meeting = ref5[0], setMeeting = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)({
        name: "",
        email: "",
        account_type: "marketplace",
        password: "",
        confirm_password: ""
    }), form = ref6[0], setForm = ref6[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var ref7 = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_10__/* .useAuth */ .a)(), user1 = ref7.user, signOut = ref7.signOut;
    var handleFormChange = function(e) {
        var newForm = _objectSpread({}, form);
        if (e.target) {
            newForm[e.target.name] = e.target.value;
            setForm(newForm);
        }
    };
    var handleChange = function(e) {
        var newMeeting = _objectSpread({}, meeting);
        if (e.target) {
            newMeeting[e.target.name] = e.target.value;
            setMeeting(newMeeting);
        }
    };
    var handleTimeChange = function(newValue) {
        var newMeeting = _objectSpread({}, meeting);
        newMeeting.timezone = newValue.value;
        setMeeting(newMeeting);
    };
    var handleDateStr = function(dateTime) {
        var newMeeting = _objectSpread({}, meeting);
        newMeeting["dateStr"] = dateTime.toFormat('DD');
        newMeeting["appointment_datetime"] = dateTime.toISO();
        setMeeting(newMeeting);
    };
    var handleUser = function(userData) {
        var newMeeting = _objectSpread({}, meeting);
        newMeeting.email = userData.email;
        newMeeting.name = userData.name;
        newMeeting.client_user_id = userData.id;
        newMeeting.client_profile_id = userData.profile_id;
        setMeeting(newMeeting);
    };
    var checkErrors = function() {
        if (form.password !== form.confirm_password) {
            var newError = _objectSpread({}, error1);
            newError = "Passwords do not match";
            setError(newError);
            return false;
        }
        if (form.password.length < 8) {
            var newError1 = _objectSpread({}, error1);
            newError1 = "Password too short";
            setError(newError1);
            return false;
        }
        if (!form.name || !form.email) {
            var newError2 = _objectSpread({}, error1);
            newError2 = "Please enter a username and email";
            setError(newError2);
            return false;
        }
        return true;
    };
    var submitRegister = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var bool, ref, user, error, rand, profile;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setLoading(true);
                        bool = checkErrors();
                        if (bool) {
                            _ctx.next = 6;
                            break;
                        }
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_12__/* .supabase.auth.signUp */ .O.auth.signUp({
                            email: form.email,
                            password: form.password
                        });
                    case 8:
                        ref = _ctx.sent;
                        user = ref.user;
                        error = ref.error;
                        if (error) {
                            _ctx.next = 22;
                            break;
                        }
                        _lib_gtag__WEBPACK_IMPORTED_MODULE_15__/* .event */ .B({
                            action: 'user_register'
                        });
                        rand = (Math.random() + 1).toString(36).substring(7);
                        _ctx.next = 16;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_12__/* .supabase.from */ .O.from("main_profile").insert({
                            user_id: user.id,
                            name: form.name,
                            account_type: form.account_type,
                            email: form.email,
                            unique_slug: rand,
                            timezone: tz
                        });
                    case 16:
                        profile = _ctx.sent;
                        _ctx.next = 19;
                        return fetch("/api/contact/register", {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                email: form.email,
                                marketplace: true
                            })
                        });
                    case 19:
                        //push to stripe subscription ?? 
                        router.push("/network/onboarding");
                        _ctx.next = 23;
                        break;
                    case 22:
                        {
                            setEmailError(error.message);
                        }
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRegister(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "jsx-174f2eebf65a3d90" + " " + "relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Meta__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                title: "Plaza Advertising Network",
                description: "The Plaza advertising network connects virtual coaches and consultants to thrid-party publishers to help coaches receive clients"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("main", {
                className: "jsx-174f2eebf65a3d90",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: "jsx-174f2eebf65a3d90" + " " + "pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "jsx-174f2eebf65a3d90" + " " + "mx-auto max-w-7xl lg:px-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "lg:grid lg:grid-cols-2 lg:gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "lg:py-12",
                                            children: [
                                                "     ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + 'mt-1',
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + 'text-fuchsia-700 bg-fuchsia-100 px-2 py-1 rounded-lg',
                                                        children: "New"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "block ",
                                                            children: [
                                                                "Focus on ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "text-fuchsia-600",
                                                                    children: " coaching"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "block ",
                                                            children: [
                                                                "not",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "underline decoration-fuchsia-600 decoration-wavy decoration-4",
                                                                    children: " marketing "
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                                                    children: "Plaza's online marketplace helps certified coaches find clients at a price point that makes sense."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "w-full mt-8 mb-10 lg:mb-0 sm:w-1/2 mx-auto lg:mx-0 md:w-1/3",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            href: "#bookDemo",
                                                            className: "jsx-174f2eebf65a3d90" + " " + "block w-full py-3 text-center px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900",
                                                            children: "Book Demo"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + " lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + 'my-auto mx-auto',
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                        width: 404,
                                                        height: 784,
                                                        fill: "none",
                                                        viewBox: "0 0 404 784",
                                                        "aria-hidden": "true",
                                                        className: "jsx-174f2eebf65a3d90" + " " + " invisible sm:visible absolute mx-auto pl-20 -z-10 transform  -translate-y-1/2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                                                                className: "jsx-174f2eebf65a3d90",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("pattern", {
                                                                    id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                                                    x: 0,
                                                                    y: 0,
                                                                    width: 20,
                                                                    height: 20,
                                                                    patternUnits: "userSpaceOnUse",
                                                                    className: "jsx-174f2eebf65a3d90",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                                        x: 0,
                                                                        y: 0,
                                                                        width: 4,
                                                                        height: 4,
                                                                        fill: "currentColor",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "text-gray-300"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                                width: 404,
                                                                height: 784,
                                                                fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)",
                                                                className: "jsx-174f2eebf65a3d90"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + 'flex flex-row justify-center space-y-1 mx-auto sm:mx-0',
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl  -ml-10 flex flex-row   absolute h-32 w-32 -z-10 bg-fuchsia-500"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + 'w-60 h-60 mr-3 -mb-5 overflow-hidden',
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                                                                    autoPlay: true,
                                                                    loop: true,
                                                                    muted: true,
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'rounded-xl w-30 h-32 object-cover object-top shadow-lg',
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                                                                        src: "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .cloudfront */ .bG, "/media/stock_videos/video-chat-woman-talk.mp4"),
                                                                        type: "video/mp4",
                                                                        className: "jsx-174f2eebf65a3d90"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + 'w-60 h-60 mb-3 mr-3 sm:pt-32',
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("video", {
                                                                    autoPlay: true,
                                                                    loop: true,
                                                                    muted: true,
                                                                    className: "jsx-174f2eebf65a3d90" + " " + 'rounded-xl w-30 h-32 object-cover shadow-lg',
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                                                                        src: "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .cloudfront */ .bG, "/media/stock_videos/video-chat-manager.mp4"),
                                                                        type: "video/mp4",
                                                                        className: "jsx-174f2eebf65a3d90"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                        className: "jsx-174f2eebf65a3d90" + " " + "relative  pt-16 pb-32 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-174f2eebf65a3d90" + " " + "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + 'z-20 relative',
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                                className: "h-6 w-6 text-white",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "mt-6 z-20 relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                children: "Who is this for?"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-lg text-gray-500",
                                                                children: "You are a certified coach whose clients are primarily professionals such as physicians, therapists, lawyers, or engineers. You want to fill empty time slots in your calendar with more clients, but do not want to commit to expensive marketing initiatives"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "pl-4 -mr-48 sm:pl-6 md:mr-16 lg:px-0 my-auto img-cont z-10",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                    className: (_styles_Business_module_css__WEBPACK_IMPORTED_MODULE_17___default().editorMockup),
                                                    src: "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .cloudfront */ .bG, "/static/marketplace_listings.png"),
                                                    width: 1474,
                                                    height: 1005,
                                                    objectFit: "contain",
                                                    alt: "Plaza for video consultations"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "relative mt-24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "jsx-174f2eebf65a3d90" + " " + "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                className: "h-6 w-6 text-white",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "mt-6 mr-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "text-3xl font-extrabold tracking-tight text-gray-900",
                                                                children: "How it Works"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-4 text-lg text-gray-500 relative z-20",
                                                                children: "Coaches can select how they are charged on the marketplace.  Whether coaches select per lead, per discovery call, or a flat fee of their total coaching package, there is no long term commitment and plenty of flexibility to find the cost that works for coaches"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "mt-6",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                    href: "#bookDemo",
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-indigo-700",
                                                                    children: "Get started"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-32 sm:mt-16 lg:mt-0 flex items-center ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 img-cont",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                                    className: "scale-150",
                                                    src: "".concat(_config__WEBPACK_IMPORTED_MODULE_6__/* .cloudfront */ .bG, "/static/marketplace_options.png"),
                                                    width: 1600,
                                                    height: 700,
                                                    objectFit: "contain",
                                                    alt: "Plaza for video consultations"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "jsx-174f2eebf65a3d90" + " " + "py-16 bg-slate-200/50 overflow-hidden lg:py-24",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + "relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                        width: 404,
                                        height: 784,
                                        fill: "none",
                                        viewBox: "0 0 404 784",
                                        "aria-hidden": "true",
                                        className: "jsx-174f2eebf65a3d90" + " " + "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                                                className: "jsx-174f2eebf65a3d90",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("pattern", {
                                                    id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                                    x: 0,
                                                    y: 0,
                                                    width: 20,
                                                    height: 20,
                                                    patternUnits: "userSpaceOnUse",
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                        x: 0,
                                                        y: 0,
                                                        width: 4,
                                                        height: 4,
                                                        fill: "currentColor",
                                                        className: "jsx-174f2eebf65a3d90" + " " + "text-gray-200"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                                width: 404,
                                                height: 784,
                                                fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)",
                                                className: "jsx-174f2eebf65a3d90"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        id: "#register",
                                        className: "jsx-174f2eebf65a3d90" + " " + "relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                className: "jsx-174f2eebf65a3d90" + " " + "text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                                children: "Register"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                id: "waitlist",
                                                className: "jsx-174f2eebf65a3d90" + " " + "w-full lg:w-1/2 mx-auto mt-10 sm:mt-12",
                                                children: !submitted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                                    action: "#",
                                                    className: "jsx-174f2eebf65a3d90" + " " + "sm:max-w-xl sm:mx-auto lg:mx-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "sm:flex",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: "jsx-174f2eebf65a3d90" + " " + "min-w-0 flex-1 space-y-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                        name: "name",
                                                                        defaultValue: form.name,
                                                                        onChange: handleFormChange,
                                                                        placeholder: "Enter your name",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600 "
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                        name: "email",
                                                                        defaultValue: form.email,
                                                                        onChange: handleFormChange,
                                                                        placeholder: "Enter your email",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                        name: "password",
                                                                        type: "password",
                                                                        defaultValue: form.password,
                                                                        onChange: handleFormChange,
                                                                        placeholder: "Enter password",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                        name: "confirm_password",
                                                                        type: "password",
                                                                        defaultValue: form.confirm_password,
                                                                        onChange: handleFormChange,
                                                                        placeholder: "Confirm your password",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                                    }),
                                                                    error1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                                        className: "jsx-174f2eebf65a3d90" + " " + 'text-red-600',
                                                                        children: error1
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-6",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                onClick: submitRegister,
                                                                className: "jsx-174f2eebf65a3d90" + " " + "block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900",
                                                                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    className: "jsx-174f2eebf65a3d90" + " " + "flex justify-center",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        fill: "none",
                                                                        viewBox: "0 0 24 24",
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "animate-spin h-5 w-5 my-auto text-zinc-200 ",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "10",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "4",
                                                                                className: "jsx-174f2eebf65a3d90" + " " + "opacity-25"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                                                fill: "currentColor",
                                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                                                                                className: "jsx-174f2eebf65a3d90" + " " + "opacity-75"
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : "Register"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                            className: "jsx-174f2eebf65a3d90" + " " + "mt-3 text-sm text-center text-gray-600 sm:mt-4",
                                                            children: [
                                                                " By providing your email, you agree to our",
                                                                ' ',
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                                    href: "/terms-conditions",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                                        className: "jsx-174f2eebf65a3d90" + " " + "font-medium text-gray-900",
                                                                        children: "terms of service"
                                                                    })
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                }) : submitted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "jsx-174f2eebf65a3d90" + " " + "flex items-center justify-center ",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                            className: "text-green-600 h-7 w-7 mr-3"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: "jsx-174f2eebf65a3d90",
                                                            children: "Thanks for joining.  We'll follow-up in the upcoming weeks."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "blur-3xl right-0 mr-48 absolute h-32 w-48 -z-10 bg-fuchsia-400"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        id: "bookDemo",
                                        className: "jsx-174f2eebf65a3d90" + " " + "relative",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "jsx-174f2eebf65a3d90" + " " + "min-h-full flex flex-col justify-center mt-48 py-12 sm:px-6 lg:px-8",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "jsx-174f2eebf65a3d90" + " " + " sm:mx-auto sm:w-full sm:max-w-3xl",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "text-center text-3xl mb-16 leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                                        children: "Book a Demo"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "jsx-174f2eebf65a3d90" + " " + "bg-white  w-full shadow-xl sm:rounded-lg ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Gthr_Scheduler_Utils_Calendar__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            meeting: meeting,
                                                            handleChange: handleChange,
                                                            handleDateStr: handleDateStr,
                                                            handleTimeChange: handleTimeChange,
                                                            handleUser: handleUser,
                                                            subPage: subPage,
                                                            setSubPage: setSubPage,
                                                            setMeeting: setMeeting,
                                                            business: true,
                                                            activity: null,
                                                            setCheckUser: setCheckUser,
                                                            checkUser: checkUser,
                                                            slug: "6vto"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "jsx-174f2eebf65a3d90" + " " + '',
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {
                                        className: "jsx-174f2eebf65a3d90"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                href: "/terms-conditions",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: " Terms & Conditions | "
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                href: "/cookie-policy",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: " Cookie Policy | "
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                                href: "/privacy-policy",
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "jsx-174f2eebf65a3d90",
                                                    children: "Privacy Policy"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "jsx-174f2eebf65a3d90" + " " + "text-center text-gray-400",
                                        children: "\xa9 2023 Ordinary Media, LLC. All Rights Reserved."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "174f2eebf65a3d90",
                children: ".img-cont>span{overflow:visible!important}\nbody{overlfow\n         }"
            })
        ]
    }));
};
var alertOptions = {
    // you can also just use 'bottom right'
    position: react_alert__WEBPACK_IMPORTED_MODULE_9__/* .positions.BOTTOM_RIGHT */ .m7.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {
        'zIndex': '9999'
    },
    // you can also just use 'fade'
    transition: react_alert__WEBPACK_IMPORTED_MODULE_9__/* .transitions.FADE */ .pB.FADE
};
Network.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_alert__WEBPACK_IMPORTED_MODULE_9__/* .Provider */ .zt, _objectSpread({
        template: _components_Notification__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
    }, alertOptions, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_contexts_Auth__WEBPACK_IMPORTED_MODULE_10__/* .AuthProvider */ .H, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layouts_businessLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: page
            })
        })
    })));
};


/***/ }),

/***/ 90260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"demo_image":"Business_demo_image__2O7Rj","mockup3":"Business_mockup3__Lob0U","editorMockup":"Business_editorMockup__NXUK7","editorPreview":"Business_editorPreview__Jy2WY"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 4143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var ArrowLeft = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  }));
});
ArrowLeft.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
ArrowLeft.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeft);

/***/ }),

/***/ 65287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var CalendarWeek = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
  }));
});
CalendarWeek.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
CalendarWeek.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (CalendarWeek);

/***/ }),

/***/ 48568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var CameraVideoFill = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
  }));
});
CameraVideoFill.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
CameraVideoFill.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (CameraVideoFill);

/***/ }),

/***/ 19578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var CheckLg = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"
  }));
});
CheckLg.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
CheckLg.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckLg);

/***/ }),

/***/ 38358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var CurrencyDollar = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"
  }));
});
CurrencyDollar.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
CurrencyDollar.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrencyDollar);

/***/ }),

/***/ 41285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var EnvelopeFill = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z"
  }));
});
EnvelopeFill.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
EnvelopeFill.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (EnvelopeFill);

/***/ }),

/***/ 89019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var XLg = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["color", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
  }));
});
XLg.propTypes = {
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)])
};
XLg.defaultProps = {
  color: 'currentColor',
  size: '1em'
};
/* harmony default export */ __webpack_exports__["Z"] = (XLg);

/***/ }),

/***/ 12450:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function CalendarIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CalendarIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 37051:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function PencilAltIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(PencilAltIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 25504:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function BadgeCheckIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(BadgeCheckIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9225,5675,3640,3616,5988,7612,6848,3334,5953,9101,471,4881,9774,2888,179], function() { return __webpack_exec__(37241); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);